/**
 * Colored badge for procurement (and, later, stocktake / settlement)
 * lifecycle states. Lives next to the row header on list + detail pages.
 *
 * Colour mapping per spec 6.1:
 *   - draft     → yellow / "warning"  (in-progress, no buy-price write yet)
 *   - received  → green  / "success"  (the canonical, money-affecting state)
 *   - cancelled → red    / "error"    (terminated; receives are reversed)
 */

import { Tag } from "antd";

import type { ProcurementState } from "../../api/client";

const COLORS: Record<ProcurementState, string> = {
  draft: "gold",
  received: "green",
  cancelled: "red",
};

const LABELS: Record<ProcurementState, string> = {
  draft: "Draft",
  received: "Received",
  cancelled: "Cancelled",
};

export interface StatePillProps {
  state: ProcurementState;
}

export const StatePill = ({ state }: StatePillProps) => (
  <Tag color={COLORS[state]} style={{ marginInlineEnd: 0 }}>
    {LABELS[state]}
  </Tag>
);

export default StatePill;
